import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/core/alert.service';
import { ToastService } from 'src/app/core/toast.service';
import { ApiFreteService } from 'src/app/dao/api-frete.service';
import { ApiGruposopcionaisService } from 'src/app/dao/api-gruposopcionais.service';
import { GlobalService } from 'src/app/dao/global.service';
import { Frete } from 'src/app/model/frete';
import { Produto } from 'src/app/model/produto';

@Component({
  selector: 'app-nomeopcional',
  templateUrl: './nomeopcional.page.html',
  styleUrls: ['./nomeopcional.page.scss'],
})
export class NomeopcionalPage implements OnInit {
  // tslint:disable-next-line: no-inferrable-types
  showSearch: boolean = false;
  fretes = [];
  inicio = '';
  fim = '';
  user: string;
  pass: string;
  idCategoria;
  categoriasAux = [];


  constructor(private route: ActivatedRoute,
    private toast: ToastService,
    private alert: AlertService,
    private apiOpcs: ApiGruposopcionaisService,
    private global: GlobalService) { }



  ngOnInit() {
    this.user = this.global.user;
    this.pass = this.global.pass;
    this.loadProd();
    this.loadCategorias2();
    
    
  }

  ionViewWillEnter() {
    this.user = this.global.user;
    this.pass = this.global.pass;
    this.loadProd();
  }

  /*async loadProd() {
    console.log("entrou");
    this.apiOpcs.listarTodosNomes().then(res => {
      console.log(res);

      console.log('res', res);
      this.fretes = res;
      //this.toast.showSucess('Fretes obtidos com sucesso!');
    }).catch(async err => {
      console.log('err', err);
      this.toast.showError('Erro ao obter Fretes');
    });
  }*/


    async loadProd() {
      console.log("entrou");
    
      await this.apiOpcs.listarTodosNomes().then(res => {
        console.log('API resultado:', res);
    
        // Faz merge dos grupos fixos com os nomes retornados do banco
        this.fretes = this.categoriasAux.map(grupo => {
          const encontrado = res.find(item => item.grupo === grupo.code);
          console.log(encontrado);
          return {
            grupo: grupo.code,
            nome: encontrado ? encontrado.nome : grupo.name
          };
        });



        /*
  this.fretes.forEach(cat => {
    const correspondente = this.fretes.find(nome => nome.grupo === cat.code);
    if (correspondente) {
      cat.name = correspondente.nome;
    }
  });
    */
        console.log('Resultado final:', this.fretes);
      }).catch(err => {
        console.error('Erro ao obter Opcionais', err);
        this.toast.showError('Erro ao obter Opcionais');
      });
    }




    onRowEditInit(product) {
      console.log('Edição iniciada:', product);
    }
    
    onRowEditSave(product) {
      console.log('Salvando:', product);
      
      const payload = {
        grupo: product.grupo,
        nome: product.nome
      };
    
      this.apiOpcs.salvarNomeGrupo(payload).then(() => {
        this.toast.showSucess('Salvo com sucesso');
      }).catch(err => {
        console.error('Erro ao salvar', err);
        this.toast.showError('Erro ao salvar');
      });
    }
    
    onRowEditCancel(product, index) {
      console.log('Edição cancelada:', product);
    }

    
  searchButtonClick() {
    this.showSearch = true;
  }

  doSearchBarCancel() {
    this.showSearch = false;
    this.loadProd();
  }


  async loadCategorias2() {

    this.categoriasAux = [
    {name: 'Grupo 1', code: 'grupo1'},
    {name: 'Grupo 2', code: 'grupo2'},
    {name: 'Grupo 3', code: 'grupo3'},
    {name: 'Grupo 4', code: 'grupo4'},

    {name: 'Bordas', code: 'borda'},
    {name: 'Massas', code: 'massa'},
    {name: 'Bebidas', code: 'bebida'},
    {name: 'Misturas', code: 'misturas'},
    {name: 'Grupo Extra', code: 'grupoExtra'},


    {name: 'Grupo 5', code: 'grupo5'},
    {name: 'Grupo 6', code: 'grupo6'},
    {name: 'Grupo 7', code: 'grupo7'},
    {name: 'Grupo 8', code: 'grupo8'},
    {name: 'Grupo 9', code: 'grupo9'},
    {name: 'Grupo 10', code: 'grupo10'},
    {name: 'Grupo 11', code: 'grupo11'},
    {name: 'Grupo 12', code: 'grupo12'},
    {name: 'Grupo 13', code: 'grupo13'},
    {name: 'Grupo 14', code: 'grupo14'},
    {name: 'Grupo 15', code: 'grupo15'},
    {name: 'Grupo 16', code: 'grupo16'},
    {name: 'Grupo 17', code: 'grupo17'},
    {name: 'Grupo 18', code: 'grupo18'},
    {name: 'Grupo 19', code: 'grupo19'},
    {name: 'Grupo 20', code: 'grupo20'},
    {name: 'Grupo 21', code: 'grupo21'},
    {name: 'Grupo 22', code: 'grupo22'},
    {name: 'Grupo 23', code: 'grupo23'},
    {name: 'Grupo 24', code: 'grupo24'},
    {name: 'Grupo 25', code: 'grupo25'},
];









console.log(this.categoriasAux);
}




}
